import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-63">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-64">
        <p className="text-blue-400 font-bold mb-2" data-id="element-65">
          💙 "El crecimiento emocional más importante no es el que se ve — es el
          que se construye adentro."
        </p>
        <p data-id="element-66">
          💙 MI ESPACIO INTERIOR — © Mi Espacio Interior 2026 — Todos los
          derechos reservados.
        </p>
        <p className="text-xs text-gray-500" data-id="element-67">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <div className="flex justify-center gap-4 pt-2" data-id="element-68">
          <a href="#" className="hover:text-white transition-colors" data-id="element-69">
            Privacidad
          </a>
          <span data-id="element-70">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-71">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}